import React from 'react';
import {Box, Button, IconButton, Tooltip, useMediaQuery, useTheme} from '@mui/material';
import {Add, DeleteForeverOutlined, EditOutlined, Refresh, HistoryOutlined} from '@mui/icons-material';
import {alpha} from '@mui/material/styles';
import {reportingIconStyles, reportingToolbarStyles} from '../utils/ReportingToolbarDesign';

export default function AutomationToolbar({selectedCount, onCreate, onEdit, onDelete, onViewLogs, onRefresh, refreshing}) {
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('sm'));
    const compactActions = useMediaQuery(theme.breakpoints.down('lg'));
    const singleSelected = selectedCount === 1;

    return <Box component="section" aria-label="Automation toolbar" sx={reportingToolbarStyles}>
        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1.25,
            '@media (max-width: 359.95px)': {'& .MuiIconButton-root': {width: 32, height: 32, '& .MuiSvgIcon-root': {fontSize: 18}}}}}>
            <Box sx={{display: 'flex', alignItems: 'center', gap: 0.75}}>
                {mobile ? <Tooltip title="Create automation rule"><IconButton aria-label="Create automation rule" onClick={onCreate}
                    sx={{...reportingIconStyles, bgcolor: 'primary.main', color: 'primary.contrastText', '&:hover': {bgcolor: 'primary.dark'}}}><Add/></IconButton></Tooltip> :
                    <Button variant="contained" startIcon={<Add/>} onClick={onCreate}>Create</Button>}
                {compactActions ? <Tooltip title={singleSelected ? 'Edit automation rule' : 'Select one rule to edit'}><span>
                    <IconButton aria-label="Edit automation rule" disabled={!singleSelected} onClick={onEdit} sx={reportingIconStyles}><EditOutlined/></IconButton>
                </span></Tooltip> : <Button color="inherit" startIcon={<EditOutlined/>} disabled={!singleSelected} onClick={onEdit}>Edit</Button>}
                <Tooltip title={singleSelected ? 'View action logs' : 'Select one rule to view logs'}><span>
                    {compactActions ? <IconButton aria-label="View action logs" disabled={!singleSelected} onClick={onViewLogs}
                        sx={reportingIconStyles}><HistoryOutlined/></IconButton> :
                        <Button color="inherit" startIcon={<HistoryOutlined/>} disabled={!singleSelected} onClick={onViewLogs}>View logs</Button>}
                </span></Tooltip>
                <Tooltip title={singleSelected ? 'Delete permanently' : 'Select one rule to delete'}><span>
                    <IconButton aria-label="Delete automation rule" disabled={!singleSelected} onClick={onDelete}
                        sx={{...reportingIconStyles, color: 'error.main',
                            '&:hover': {color: 'error.main', bgcolor: theme => alpha(theme.palette.error.main, 0.1)}}}><DeleteForeverOutlined/></IconButton>
                </span></Tooltip>
            </Box>
            <Tooltip title="Refresh automation rules"><span>
                <IconButton aria-label="Refresh automation rules" disabled={refreshing} onClick={onRefresh} sx={reportingIconStyles}><Refresh/></IconButton>
            </span></Tooltip>
        </Box>
    </Box>;
}
